import "./style.css";

const About = () => {
  return (
    <div className="skills">
      <h1>Skills</h1>
      <div className="content">
        <div>
          <strong>Languages:</strong>
          <li>CSS3</li>
          <li>HTML5</li>
          <li>JavaScript</li>
          <li>Java</li>
        </div>
        <div>
          <strong>Libraries:</strong>
          <li>Material-ui</li>
          <li>React.js</li>
          <li>Bootstrap</li>
          <li>Express.js</li>
        </div>
        <div>
          <strong>Tools:</strong>
          
          <li>Chrome Dev</li>
          <li>Git & Github</li>
          <li>Eslint</li>
          <li>Webpack</li>
        </div>
        <div>
          <strong>Uint Test:</strong>
          <li>React-test</li>
          <li>SupperTest</li>
          <li>Jest</li>
        </div>
      </div>
    </div>
  );
};

export default About;
